import moment from "moment";
class groupsAssigned {
  constructor(grupId, name, from, to, defaultGrp) {
    this.grupId = grupId;
    this.name = name;
    this.from = moment.utc(from).format("DD-MM-YYYY");
    this.to = to == null ? " " : moment.utc(to).format("DD-MM-YYYY");
    this.defaultGrp = defaultGrp == "S" ? "✔️" : "";
  }
  static fromJson({ grupoId, nombre, fecDesde, fecHasta, defaultGrp }) {
    return new groupsAssigned(grupoId, nombre, fecDesde, fecHasta, defaultGrp);
  }
}
export default groupsAssigned;
